import { defineMessages } from 'react-intl';

// eslint-disable-next-line perfectionist/sort-object-types
/* eslint-disable perfectionist/sort-object-types */
export const messages: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/* eslint-enable perfectionist/sort-object-types */
} = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.loom',
		defaultMessage: 'Loom',
		description:
			'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Loom application.',
	},
});
